import { useEffect } from "react";
import { AlertCircle } from "lucide-react";

// Site-wide closing-down notice. Fixed at the very top; sets --banner-h so the
// (also fixed) Navigation drops below it instead of overlapping.
export const AnnouncementBanner = () => {
  useEffect(() => {
    document.documentElement.style.setProperty("--banner-h", "40px");
    return () => document.documentElement.style.setProperty("--banner-h", "0px");
  }, []);

  return (
    <div
      data-testid="announcement-banner"
      className="fixed top-0 inset-x-0 z-50 h-10 flex items-center justify-center gap-2 px-4 bg-[#f59e0b] text-black"
    >
      <AlertCircle size={15} className="flex-shrink-0" />
      <p className="font-body text-[11px] sm:text-xs tracking-[0.12em] uppercase font-semibold text-center">
        <span className="sm:hidden">Closing down — final day Dec 1.</span>
        <span className="hidden sm:inline">Velocity Paint &amp; Panel is closing down — final day December 1st.</span>
      </p>
    </div>
  );
};

export default AnnouncementBanner;
